Namespace 'Customer.Dashboard.TicketDetailsStats.Integration'

class Customer.Dashboard.TicketDetailsStats.Integration.BaseView extends Backbone.View

  render: =>
    @$el.html(@template(model: @model))
